export default {
    TABLET: 'TABLET',
    PHONE: 'PHONE',
    HOME: 'HOME PAGE',
    CHECKOUT: 'CHECKOUT',
    MENU: 'MENU',
    REGULAR: 'REGULAR',
    DISCOUNTED: 'DISCOUNTED',
    DELIVERY: 'DELIVERY',
    PICKUP: 'PICKUP',
    CASH: 'CASH',
    CARD: 'CARD',
};
